import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Progress: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.7867 3.33325c1.04 1.04 1.04 2.73332 0 3.77332H28.8L11.3867 24.5199l-8.70668 3.48 3.48-8.7066L23.5733 1.87992c.52-.52 1.2-.78666 1.88-.78666.68 0 1.36.26666 1.88.78666l1.4534 1.45333Zm-3.3334-.50666c-.2533 0-.4933.10665-.6666.27998v-.0133L8.60002 19.2799l2.77338 2.7734L27.56 5.86657c.1867-.17333.28-.41332.28-.65332s-.1067-.47998-.28-.65332l-1.4533-1.45336c-.1734-.18666-.4-.27998-.6534-.27998ZM7.48002 20.6399l-1.70666 4.2534.01333.0133L10.04 23.1999l-2.55998-2.56Zm21.85328 8.6933H4.72002l4.33334-1.7333H29.3333v1.7333Z"
      clipRule="evenodd"
    />
  </Icon>
);
